module.exports = __webpack_public_path__ + "img/ailaan .3ea6e1c1.jpg";